import { reactive, watch } from 'vue';
import BaseSetupService from '@/setup/BaseSetupService';
import { OrionAside } from '@orion.ui/orion/dist/types/packages';
import TempWorkerUnavailabilitiesEntity from '@/entity/TempWorkerUnavailabilitiesEntity';

type Props = SetupProps<typeof UserProfileUnavailabilityAsideNewSetupService.props>

export default class UserProfileUnavailabilityAsideNewSetupService extends BaseSetupService<Props> {
	static readonly props = {};
	protected _aside?: OrionAside;
	protected readonly entity = new TempWorkerUnavailabilitiesEntity();

	private readonly state = reactive({ period: undefined as any });

	get period () { return this.state.period; }
	set period (val) { this.state.period = val; }

	constructor (props?: Props, _aside?: OrionAside) {
		super(props);
		this._aside = _aside;

		watch(() => this.period, (val) => {
			if (val?.start && val?.end) {
				this.entity.startDate = val.start.toPost();
				this.entity.endDate = val.end.toPost();
			}
		});
	}

	async addUnavailabilityAsync () {
		const res = await this.entity.addUnavailabilityAsync();
		this._aside?.bus.emit('add', res);
	}

}
